/**
 * Tipos aceites para extrair `elementId` do layout e para reconhecer itens no JSON do carousel.
 * Inclui `rowads-banner` onde o backend reutiliza o mesmo contrato.
 */
const ROW_AD_BANNER_TYPE_ALIASES = new Set([
  'rowads-banner',
]);

/**
 * @param {unknown} type
 * @returns {boolean}
 */
export function isRowAdBannerApiType(type) {
  return typeof type === 'string' && ROW_AD_BANNER_TYPE_ALIASES.has(type);
}
